import {createContext, useContext, useState, ReactNode} from 'react'

export const SETTINGS_ENDPOINT_CONFIG_SNAPSHOT =
  'endpointsSettingConfigSnapshot'

export interface SnapshotContextProps {
  snapshot?: {[key: string]: unknown} | null
  setSnapshot: (value: {[key: string]: unknown}) => void
}

export const SnapshotContext = createContext<SnapshotContextProps>({
  snapshot: null,
  setSnapshot: () => null,
})

export interface SnapshotProviderProps {
  children: ReactNode
}

export const SnapshotProvider = ({children}: SnapshotProviderProps) => {
  const [snapshot, setSnapshot] = useState<{[key: string]: unknown}>()

  return (
    <SnapshotContext.Provider value={{snapshot, setSnapshot}}>
      {children}
    </SnapshotContext.Provider>
  )
}

export const useSnapshotContext = () => {
  return useContext(SnapshotContext)
}
